import React, { useEffect } from "react";
import User_Management_Routes from "./user_management_routes/User_Management_Routes";
import User_Management_Sidebar from "./user_management_sidebar/User_Management_Sidebar";
import "./User_Management_Page.css";
import { useDispatch } from "react-redux";
import { GETAuthLogin } from "../../../features/auth/Slice";

const User_Management_Page = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);
  return (
    <section className="User_Management_Page">
      <div className="row me-0 ms-0 p-0">
        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-4 ps-md-0  p-0">
          <User_Management_Sidebar />
        </div>
        <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-8 col-sm-8 p-0">
          <User_Management_Routes />
        </div>
      </div>
    </section>
  );
};

export default User_Management_Page;
